import type { RequestOptions } from './request';

export function useMessageAPI() {
  const { errors, request } = useRequestV2();

  async function fetchMessagesForFitter(fitterId: number) {
    return await request<MessageDTO[]>(`V3/Message/ForFitter?fitterId=${fitterId}`);
  }

  async function markMessageAsRead(messageId: number) {
    const requestOptions: RequestOptions = {
      method: 'POST'
    };

    return await request<boolean>(`V3/Message/MarkAsRead?messageId=${messageId}`, requestOptions);
  }

  async function markAllUnreadAsRead(fitterId: number) {
    const requestOptions: RequestOptions = {
      method: 'POST'
    };

    return await request<boolean>(`V3/Message/MarkAllUnreadAsRead?fitterId=${fitterId}`, requestOptions);
  }

  async function deleteMessage(messageId: number) {
    const requestOptions: RequestOptions = {
      method: 'DELETE'
    };

    return await request<boolean>(`V3/Message/Delete?messageId=${messageId}`, requestOptions);
  }

  return {
    errors,
    fetchMessagesForFitter,
    markMessageAsRead,
    markAllUnreadAsRead,
    deleteMessage
  };
}
